import { useState, useEffect } from "react";
import { ReservationService } from "../services/ReservationService";
import Logo from "../components/Logo";
import Icon from "@mdi/react";
import { mdiMapMarker } from "@mdi/js";
import BackButton from "../components/BackButton";
import {
  formatDateLabel,
  formatReservationDateTime,
} from "../helpers/formatDateLabel";

export default function ReservationHistory() {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReservations = async () => {
      const service = new ReservationService();
      try {
        const data = await service.getReservationHistory();
        setReservations(data?.items || []);
        setError(null);
      } catch (err) {
        console.error("Erro ao buscar reservas:", err);
        setError("Nenhuma reserva encontrada.");
      } finally {
        setLoading(false);
      }
    };

    fetchReservations();
  }, []);

  const handleShowMap = (address) => {
    if (!address) return;
    const { street, number, neighborhood, city, zipCode } = address;
    const query = `${street} ${number} - ${neighborhood}, ${city}, ${zipCode}`;
    window.open(
      `https://www.google.com/maps/place/${encodeURIComponent(query)}`
    );
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <h2>Carregando reservas...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center p-5">
        <h2>{error}</h2>
      </div>
    );
  }

  if (reservations.length === 0) {
    return (
      <>
        <div
          className="d-flex align-items-center justify-content-center position-relative"
          style={{ height: "125px" }}
        >
          <BackButton />
          <Logo center className="mb-4" size="125px" />
        </div>

        <div className="text-center p-5">
          <h2>Nenhuma reserva encontrada.</h2>
        </div>
      </>
    );
  }

  return (
    <div className="container p-5">
      <div
        className="d-flex align-items-center justify-content-center position-relative"
        style={{ height: "125px" }}
      >
        <BackButton />
        <Logo center className="mb-4" size="125px" />
      </div>

      <div>
        <h1 className="text-center text-uppercase fw-bold mb-5">
          Reservas Antigas
        </h1>
      </div>

      {reservations.map((reservation, index) => (
        <div className="row" key={reservation._id || index}>
          <div className="col-12 mb-4 text-center">
            <div className="mb-2">
              {reservation.canceled ? (
                <h2 style={{ color: "red", fontWeight: "bold" }}>CANCELADA</h2>
              ) : (
                <h2 style={{ color: "green", fontWeight: "bold" }}>OK</h2>
              )}
              <div className="fw-bold text-uppercase fs-2 mb-2">
                {formatDateLabel(reservation.date, reservation.type)}
              </div>
              <div>{formatReservationDateTime(reservation.startHour)}</div>
            </div>
            <div>
              <div>{reservation.school?.name || "Escola não encontrada"}</div>
              <div>
                {reservation.school?.address?.neighborhood || "Sem endereço"}
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="px-3">
              <div
                className="row align-items-center justify-content-center border border-secondary border-2 rounded-4 pb-3 pt-3"
                onClick={() => handleShowMap(reservation.school?.address)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="col-1"
                  style={{ width: "fit-content", marginLeft: "-25px" }}
                >
                  <Icon path={mdiMapMarker} size={1} color="secondary" />
                </div>
                <div
                  className="col-11 text-center"
                  style={{ width: "fit-content" }}
                >
                  {reservation.school?.address?.street},{" "}
                  {reservation.school?.address?.number}
                  <br />
                  {reservation.school?.address?.neighborhood}
                  <br />
                  {reservation.school?.address?.city} -{" "}
                  {reservation.school?.address?.zipCode}
                </div>
              </div>
            </div>

            <hr className="my-4 border-2 border-secondary" />
          </div>
        </div>
      ))}
    </div>
  );
}
